import { render, staticRenderFns } from "./SubjectRetention.vue?vue&type=template&id=290c8645&"
import script from "./SubjectRetention.vue?vue&type=script&lang=js&"
export * from "./SubjectRetention.vue?vue&type=script&lang=js&"
import style0 from "./SubjectRetention.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports